import React from 'react';
import styled from '@emotion/styled';
import colors from "styles/colors";
import dimensions from "styles/dimensions";
import { Inner } from 'styles/structure';
import Content from 'components/_ui/Content';

const JoinUsContainer = styled.div`
  & + * {
    margin-top: 8rem;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 10.4rem;
    }
  }
`;

const JoinUsHeader = styled.header`
  padding: 8rem 0 6.4rem;
  
  h3 {
    & + * {
      margin-top: 1.6rem;
    }
  }
  
  p {
    max-width: 74.8rem;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 12rem 0;
  }
`;

const JoinUsContent = styled.div`
  position: relative;
  padding-top: 6.4rem;
`;

const JoinUsBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  
  &::after {
    content: '';
    display: block;
    padding-bottom: 64rem;
  }
  
  img {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const JoinUsQuotes = styled.div`
  min-height: 57.6rem;
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
  }
`;

const JoinUsCards = styled.ul`
  display: block;
  margin: 0 auto;
  max-width: 74.8rem;
  
  li {  
    background-color: ${colors.orange100};
    
    > div {
      padding: 2.4rem;
    }
    
    & + * {
      margin-top: 3.2rem;
    }
  }
  
  img {
    width: 100%;
  }

  p {
    &::before {
      content:"\\201C";
    }
    
    &::after {
      content:"\\201D";
    }
  }
  
  cite {
    display: block;
    margin-top: 1.6rem;
    color: ${colors.teal800};
    font-style: normal;
    font-size: 2.1rem;
    font-weight: 500;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 66.6667%;
    margin-right: 5.6vw;
    
    li {         
      & + * {
        margin-top: 4rem;
      }
    }
  
    img {
      display: none;
    }
  }
  
  @media(min-width: ${dimensions.desktopUp}px) {
    flex: 1 1 50%;
    
    li {     
      > div {
        padding: 4rem 4.8rem 3.2rem;
      }
    }
  }
`;

const JoinUsImages = styled.ul`
  display: none;
  margin-top: -12vw;
  
  img {
    display: block;
    width: 100%;
    height: auto;
  }
  
  li {
    & + * {
      margin-top: 4rem;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: block;
    flex: 1 1 47.6rem;
  }
  
  @media(min-width: ${dimensions.desktopUp}px) {
    margin-top: -17.6rem;
  }
`;

const JoinUs = ({ heading, content, background, quotes }) => {
  return (
    <JoinUsContainer>
      <JoinUsHeader>
        <Inner>
          {heading && <h3>{heading}</h3>}
          {content && <Content content={content}/>}
        </Inner>
      </JoinUsHeader>

      <JoinUsContent>
        {background && (
        <JoinUsBackground>
          <img src={background.url} alt={background.alt} loading="lazy" />
        </JoinUsBackground>
        )}

        {quotes && (
          <Inner>
            <JoinUsQuotes>
              <JoinUsCards>
                {quotes.map((quote, i) => (
                  <li key={i}>
                    {quote.image && <img src={quote.image.url} alt={quote.image.alt} loading="lazy" />}

                    <div>
                      {quote.quote && <p className='is-large'>{quote.quote}</p>}
                      {quote.cite && <cite>{quote.cite}</cite>}
                    </div>
                  </li>
                ))}
              </JoinUsCards>

              <JoinUsImages>
                {quotes.map((quote, i) => (
                  <li key={i}>
                    {quote.image && <img src={quote.image.url} alt={quote.image.alt} loading="lazy" />}
                  </li>
                ))}
              </JoinUsImages>
            </JoinUsQuotes>
          </Inner>
        )}
      </JoinUsContent>
    </JoinUsContainer>
  );
};

export default JoinUs;
